<template>
    <preference-section :title="$config('PREFERENCIAS')">
        <div
            class="flex flex-col sm:flex-row items-center justify-between w-full font-secondary text-middle text-blue mb-8"
        >
            <span>{{ authenticatedUser.name }}</span>

            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                :to="{ name: 'preference', params: { field: 'name' } }"
                >{{ $config("CHANGE") }} {{ $config("NAME") }}</btn
            >
        </div>

        <div
            class="flex flex-col sm:flex-row items-center justify-between w-full font-secondary text-middle text-blue mb-8"
        >
            <span>{{ authenticatedUser.username }}</span>

            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                :to="{ name: 'preference', params: { field: 'username' } }"
                >{{ $config("CHANGE") }} {{ $config("USERNAME") }}</btn
            >
        </div>

        <div
            class="flex flex-col sm:flex-row items-center justify-between w-full font-secondary text-middle text-blue mb-8"
        >
            <span>***********</span>

            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                :to="{ name: 'preference', params: { field: 'password' } }"
                >{{ $config("CHANGE") }} {{ $config("PASSWORD") }}</btn
            >
        </div>

        <div
            v-if="userSubscriptionIsActive"
            class="flex flex-col sm:flex-row items-center justify-end w-full font-secondary text-middle text-blue mb-8"
        >
            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                :to="{
                    name: 'preference',
                    params: { field: 'payment_methods' }
                }"
                >{{ $config("CHANGE") }} {{ $config("PAYMENT_METHOD") }}</btn
            >
        </div>

        <div
            v-if="userSubscriptionIsActive"
            class="flex flex-col sm:flex-row items-center justify-end w-full font-secondary text-middle text-blue mb-8"
        >
            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                @click="cancelSubscription"
                >{{ $config("CANCELPLAN") }}</btn
            >
        </div>

        <div
            v-if="userCanApplyPromocode"
            class="flex flex-col sm:flex-row items-center justify-end w-full font-secondary text-middle text-blue mb-8"
        >
            <btn
                class="rounded-large bg-orange text-white text-xs py-2 px-4"
                :to="{
                    name: 'preference',
                    params: { field: 'promo_code' }
                }"
                >{{ $config("APPLY_PROMOCODE") }}</btn
            >
        </div>

        <div
            v-if="userSubscriptionIsCancelled"
            class="flex flex-col sm:flex-row items-center justify-center w-full font-secondary text-middle text-blue mt-10"
        >
            {{ $config("CANCELLED_INFO") }} {{ accountValidUntil }}
        </div>
    </preference-section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import allowAuthenticatedOnly from "../mixins/allowAuthenticatedOnly";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";
import PreferenceSection from "../components/PreferenceSection";
import Btn from "../components/Btn";
import { format } from "date-fns";

export default {
    name: "preferences",

    mixins: [allowAuthenticatedOnly, requestWithInteractions],

    components: { PreferenceSection, Btn },

    computed: {
        ...mapState(["authenticatedUser"]),
        ...mapGetters([
            "userSubscriptionIsActive",
            "userSubscriptionIsCancelled",
            "userCanApplyPromocode"
        ]),

        accountValidUntil() {
            return format(
                new Date(this.authenticatedUser.validdate),
                "dd/MM/yyyy"
            );
        }
    },

    methods: {
        async cancelSubscription() {
            let { value: cancelConfirmed } = await this.$swal({
                title: this.$config("CONFIRM_SUBSCRIPTION_CANCELATION"),
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: this.$config("CANCELAR")
            });

            if (cancelConfirmed) {
                this.sendRequest(api.cancelSubscription(), {
                    beforeSendText: this.$config("SAVING_PREFERENCES"),
                    successText: this.$config("yoursubcancel"),
                    onSuccess: response => {
                        this.$store.commit(
                            "SET_AUTHENTICATED_USER",
                            response.userdata
                        );
                        this.$store.commit(
                            "SET_AUTHENTICATED_USER_ACCESS",
                            response.access
                        );
                    }
                });
            }
        }
    }
};
</script>
